import { getPinTemplate } from 'www/vue_components/common/PopupMap/functions/utils'

function getPinForMultiRouteInstance() {
  const startTemplate = getPinTemplate({
    text: 'A',
    classes: 'error',
    isOnMap: true,
  })
  const finishTemplate = getPinTemplate({
    text: 'B',
    classes: 'primary',
    isOnMap: true,
  })

  const startPin = ymaps.templateLayoutFactory.createClass(startTemplate)
  const finishPin = ymaps.templateLayoutFactory.createClass(finishTemplate)

  return [startPin, finishPin]
}

export default getPinForMultiRouteInstance
